export default __webpack_public_path__ + "static/media/icon_360.42dbd3fb.svg";